// Funktion zum Erstellen der Schaltflächen und Hinzufügen zur Seite
function addScrollButtons() {
    // Container für die Tabelle
    const container = document.getElementById('vergleichs_tabelle');
    var table = container.childNodes[0];
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" x="0" y="0" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M484.14 226.886 306.46 49.202c-5.072-5.072-11.832-7.856-19.04-7.856-7.216 0-13.972 2.788-19.044 7.856l-16.132 16.136c-5.068 5.064-7.86 11.828-7.86 19.04 0 7.208 2.792 14.2 7.86 19.264L355.9 207.526H26.58C11.732 207.526 0 219.15 0 234.002v22.812c0 14.852 11.732 27.648 26.58 27.648h330.496L252.248 388.926c-5.068 5.072-7.86 11.652-7.86 18.864 0 7.204 2.792 13.88 7.86 18.948l16.132 16.084c5.072 5.072 11.828 7.836 19.044 7.836 7.208 0 13.968-2.8 19.04-7.872l177.68-177.68c5.084-5.088 7.88-11.88 7.86-19.1.016-7.244-2.776-14.04-7.864-19.12z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg>';

    // Überprüfen, ob der Container existiert
    if (!container) {
        console.error('Der Container mit der ID "vergleichs_tabelle" wurde nicht gefunden.');
        return;
    }

    // Erstellen der Schaltfläche zum Scrollen nach links
    const scrollLeftButton = document.createElement('button');
    scrollLeftButton.innerHTML = svg;
    scrollLeftButton.id = 'scroll-left';
    scrollLeftButton.style.position = 'absolute';
    scrollLeftButton.style.left = '0';

    // Erstellen der Schaltfläche zum Scrollen nach rechts
    const scrollRightButton = document.createElement('button');
    scrollRightButton.innerHTML = svg;
    scrollRightButton.id = 'scroll-right';
    scrollRightButton.style.position = 'absolute';
    scrollRightButton.style.right = '0';

    // Hinzufügen der Schaltflächen zum Container
    container.appendChild(scrollLeftButton);
    container.appendChild(scrollRightButton);

    // Event-Listener für die Schaltflächen
    scrollLeftButton.addEventListener('click', function() {
        container.scrollLeft -= table.clientWidth / 6; // Scrollt um eine Zelle nach links
        updateButtonVisibility();
    });

    scrollRightButton.addEventListener('click', function() {
        container.scrollLeft += table.clientWidth / 6; // Scrollt um eine Zelle nach rechts
        updateButtonVisibility();
    });

    // Funktion zur Aktualisierung der Sichtbarkeit der Schaltflächen
    function updateButtonVisibility() {
        scrollLeftButton.style.display = container.scrollLeft === 0 ? 'none' : 'block';
        scrollRightButton.style.display = container.scrollLeft + container.clientWidth >= table.clientWidth ? 'none' : 'block';
    }

    // Initiale Überprüfung, ob die Tabelle scrollbar ist
    if (container.scrollWidth <= container.clientWidth) {
        scrollLeftButton.style.display = 'none';
        scrollRightButton.style.display = 'none';
    } else {
        updateButtonVisibility();
    }

    // Event-Listener für das Scrollen des Containers
    container.addEventListener('scroll', updateButtonVisibility);
}

// Warten, bis der DOM vollständig geladen ist, bevor die Schaltflächen hinzugefügt werden
document.addEventListener('DOMContentLoaded', function() {
    console.log("Fenster wurde geladen");
    var cont = document.getElementById('vergleichs_tabelle');
    if (cont) {
        addScrollButtons();
    }
});